import { PreguntaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";
import { Exporter } from "../Exporter";

export class ExporterText implements Exporter {
    public puedeExportar(pregunta: PreguntaDTO): boolean {
        return pregunta.tipo === PreguntasTipoEnum.TEXT;
    }

    public exportar(respuestas: any, respuesta: any[], pregunta: PreguntaDTO): void {
        respuestas[pregunta.texto] = respuesta[1];
    }
}
